export const VERTICAL_BAR_TOP_RADIUS = [3, 3, 0, 0] as const;
export const VERTICAL_BAR_BOTTOM_RADIUS = [0, 0, 3, 3] as const;
export const HORIZONTAL_BAR_END_RADIUS = [0, 3, 3, 0] as const;
